import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-designation-form',
  templateUrl: './designation-form.component.html',
  styleUrls: ['./designation-form.component.css']
})
export class DesignationFormComponent implements OnInit {
 title =  'Designation Details';
 data : any = {};
 formInvalid : boolean = false;
 d : any = {};
 fileToUpload: File = null;


 mode : string;
  DE_Id: any;

  constructor(public service : UserService,private router: Router,private route: ActivatedRoute,  private errorHandler: ErrorHandler) { }

  ngOnInit() {
  
  this.route.params.subscribe(params => {      
    this.DE_Id = params['DE_Id'];  
    this.mode  =   params['mode'];   
      
      if(this.DE_Id > 0){
        this.getbyid(this.DE_Id)
      }    
      
  });

  if(this.mode=='view'){
    this.title = "View Designation";
  }
  else if(this.mode=='edit'){
    this.title = "Edit Designation";
  } 
 
}

SaveDistrict(Distict: NgForm){
      
  if(Distict.invalid)
  {
    this.formInvalid = true;
    swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
    return;
  }     

  else{                                     
          this.data = this.service.Postdesignation(Distict.value);    
          this.data.subscribe(
          (response) => {
            Distict.reset();
            Distict.resetForm();
            Distict.form.markAsPristine();
            Distict.form.markAsUntouched();        
            swal('Success!', 'Designation Added Successfully .', 'success');
            this.router.navigate(['/home/designation']) ;   
            document.getElementById('loader-spinner').style.display = "none";           
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401) {
              this.errorHandler.HandlerError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });    
  
  
  } 
}
cancel(){
  this.d.district_name="";
}

UpdateDistrict(District: NgForm) { 
  debugger 
  this.data = this.service.updatedesignation(District.value,this.DE_Id);
 this.data.subscribe(
   (response) => {
    District.reset();
    District.resetForm();
    District.form.markAsPristine();
    District.form.markAsUntouched();           
                 
     swal('Success!', 'Designation updated Successfully .', 'success');
       
     this.router.navigate(['/home/designation']) ; 
     document.getElementById('loader-spinner').style.display = "none";          
   }, (error) => {
     document.getElementById('loader-spinner').style.display = "none";
     if (error.status == 401) {
       this.errorHandler.HandlerError(error);
     }
     else if (error.status == 400) {
      swal('Warning!', error.error.Message, 'warning');
     }
   });   
}
getbyid(DE_Id) {
  {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getbyDesignation(DE_Id);
    this.data.subscribe(
      (response: any) => {
      this.d = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

}
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/designation/designation-form/designation-form.component.ts